
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Services from './components/Services';
import CTA from './components/CTA';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'JBS Consulting, LLC',
  description:
    'Business turnaround and restructuring consulting for distressed small and mid-market companies. Services include Cash Flow Coach, Turnaround Services, Fiduciary Services, Litigation Consulting, Capital Solutions, and CXO Services.',
  url: siteUrl,
  logo: `${siteUrl}/vite.svg`,
  email: 'info@jbsconsulting.xyz',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '200 S. Wacker Drive, Suite 3100',
    addressLocality: 'Chicago',
    addressRegion: 'IL',
    postalCode: '60606',
    addressCountry: 'US',
  },
  sameAs: ['https://www.linkedin.com/company/jbsconsulting'],
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'info@jbsconsulting.xyz',
    contactType: 'Customer Service',
    availableLanguage: 'English',
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Turnaround & Restructuring Services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Cash Flow Coach' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Business Turnaround Services' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Fiduciary Services' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Litigation Consulting' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Capital Solutions' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'CXO Services' } },
    ],
  },
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <title>JBS Consulting – Business Turnaround &amp; Restructuring Consulting Chicago</title>
      <meta name="description" content="JBS Consulting, LLC delivers expert business turnaround, restructuring, and cash flow consulting for distressed small and mid-market companies. Fixed fee, fixed timeline. Serving Chicago and nationwide." />
      <meta name="keywords" content="business turnaround consulting, cash flow coach, restructuring consulting, distressed business Chicago" />
      <link rel="canonical" href={`${siteUrl}/`} />
      <meta property="og:title" content="JBS Consulting – Business Turnaround & Restructuring Consulting Chicago" />
      <meta property="og:description" content="The trusted turnaround partner for distressed businesses. Fixed fee, fixed timeline. Cash Flow Coach, Fiduciary Services, Capital Solutions, and more." />
      <meta property="og:url" content={`${siteUrl}/`} />
      <meta property="og:type" content="website" />
      <script type="application/ld+json">{JSON.stringify(schemaJsonLd)}</script>
      <Navbar />
      <Hero />
      <Features />
      <Services />
      <CTA />
      <Footer />
    </div>
  );
}
